import { createHash } from 'node:crypto';

/** Stable UTF-8 digest of `JSON.stringify` for cache change detection (Node built-in). */
export function hashJsonUtf8Sha256(value: unknown): string {
  return createHash('sha256').update(JSON.stringify(value), 'utf8').digest('hex');
}
